import { ProgressChecklistItem } from '@app/components/ProgressChecklist'
import { ListingProgressV2Status } from '@app/models/enums'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Collapse, ListGroup, ListGroupItem } from 'reactstrap'
import { IListingState } from '../modules/listing'
import { ICurrentUserState } from '@app/store/modules/account'
import { RouteComponentProps } from 'react-router'
import ListingProgress from './ListingProgress'

export type ListingProgressV2Props = IListingState &
  RouteComponentProps<{ id: string }> &
  ICurrentUserState

export const ListingProgressV2: React.FC<ListingProgressV2Props> = (props) => {
  const { ongoing, twoWeekDeadline: twd } = props.listing.progressV2

  return (
    <div>
      <ListGroup flush>
        <ListGroupItem>
          <ListingProgressGroup
            title='Within 2 Weeks'
            list={[
              {
                title: 'Generate applicable documents using form simplicity',
                status: twd.generatedDocuments,
              },
              {
                title:
                  'Listing agreement signed, uploaded to software and executed copy sent to all parties',
                status: twd.sentAndUploadedSignedListingAgreement,
              },
              {
                title: 'Listing date and expiration date',
                status: twd.attachedListingDates,
              },
              {
                title: 'Thank you note to owner(s)',
                status: twd.sentOwnerThankyou,
              },
              {
                title: 'Property info added in software with owner information',
                status: twd.attachedPropertyAndOwnerInfo,
              },
              {
                title: 'Listing agreement uploaded to software',
                status: twd.attachedListingAgreement,
              },
              {
                title:
                  'Listing coordinator sends critical dates blast through software',
                status: twd.sentCriticalDatesBlast,
              },
              {
                title: 'Signage delivered to listing site',
                status: twd.deliveredSignage,
              },
              {
                title: 'Drone footage and photos',
                status: twd.attachedPhotosAndFootage,
              },
              {
                title: 'Marketing package created - sent to owner for approval',
                status: twd.sentMarketingPackageOwner,
              },
              {
                title: 'Any owner revisions made to marketing package',
                status: twd.attachedOwnerRevisions,
              },
              {
                title:
                  'Upload owner approved package to LoopNet, Crexi, CoStar',
                status: twd.uploadedPackageToPlatforms,
              },
              {
                title:
                  'Send owner(s) links to listing platform services (LoopNet, Crexi, HaagBrown)',
                status: twd.sentOwnersListingPlatformLinks,
              },
              {
                title: 'Personal email to prospects',
                status: twd.sentPersonalEmailToProspects,
              },
              {
                title:
                  'Send email marketing package to Economic Development Commission',
                status: twd.sentMarketingPackageEDC,
              },
              {
                title:
                  'Title Commitment, Seller Property Disclosure, Survey if applicable',
                status: twd.attachedTitleCommitmentPropertyDisclosureAndSurvey,
              },
            ]}
          />
        </ListGroupItem>
        <ListGroupItem>
          <ListingProgressGroup
            title='Ongoing'
            list={[
              {
                title: 'Monthly followups with owner',
                status: ongoing.sentMonthlyFollowups,
              },
              {
                title: 'Personal email to prospects',
                status: ongoing.sentPersonalEmailToProspects,
              },
              {
                title: 'Monthly blast on LoopNet and Crexi',
                status: ongoing.sentMonthlyBlastListingPlatform,
              },
            ]}
          />
        </ListGroupItem>
      </ListGroup>
    </div>
  )
}

type ListingProgressItemProps = {
  list: Array<{ title: string; status: ListingProgressV2Status }>
  title: string
}

const ListingProgressGroup: React.FC<ListingProgressItemProps> = ({
  list,
  title,
}) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const toggleIsOpen = () => setIsOpen(!isOpen)

  return (
    <>
      <button
        onClick={toggleIsOpen}
        style={{ backgroundColor: 'white', border: 'none' }}
      >
        <FontAwesomeIcon icon={isOpen ? 'caret-down' : 'caret-right'} />
        {'\t' + title}
      </button>
      <Collapse isOpen={isOpen}>
        <ListGroup flush>
          {list.map((x, index) => {
            return (
              <ProgressChecklistItem
                key={`progress-item-${index}`}
                label={x.title}
                isVisible={x.status !== ListingProgressV2Status.Ignore}
                isComplete={x.status == ListingProgressV2Status.Complete}
              />
            )
          })}
        </ListGroup>
      </Collapse>
    </>
  )
}
